import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { ThemePalette } from '@angular/material/core';

@Component({
	selector: 'app-action-button',
	templateUrl: './action-button.component.html',
	styleUrls: ['./action-button.component.scss']
})
export class ActionButtonComponent implements OnInit {

	// Si este botón es el único que está adentro de un form va a hacer de submit salvo que se le especifique variable type

	@Input() matColor : ThemePalette = "primary";
	@Input() bDisabled = false;
	@Input() bWorking = false;
	@Input() bAutomaticallyBusyOnClick = false;
	bError = false;

	@Input() busyCaption! : string;
	@Input() idleCaption! : string;
	caption! : string;
	
	@Input() classes = ""; // Solo globales, porque las clases definidas en otro componente no van a ser accesibles desde ActionButtonComponent
	@Input() style = "";
	@Input() matIcon? : string;
	@Input() size : "large"|"medium" = "large";
	@Input() matStyle : "mat-flat-button"|"mat-button" = "mat-flat-button";

	// Si es el botón de enviar un form, tiene que ser submit
	// Si tiene otro uso, hay que ponerle tipo button y agarrar el evento eeClick
	@Input() type! : "button"|"submit";
	@Output() eeClick = new EventEmitter<void>();

	@ViewChild("button") button! : MatButton;

	emit() {
		if (this.bAutomaticallyBusyOnClick)
			this.bWorking = true;
		this.eeClick.emit();
	}
	
	setIdleCaption(caption : string) {
		this.idleCaption = caption;
		this.caption = this.idleCaption;
	}

	ngOnInit() {
		this.caption = this.idleCaption;
	}

	showError(errorCaption:string) {
		this.bError = true;
		this.matColor = "warn";
		this.caption = errorCaption;
		this.button._elementRef.nativeElement.setAttribute("aria-label", errorCaption);
		setTimeout(() => {
			this.button.focus();
			this.bDisabled = true;
		}, 0);
	}

	clearError() {
		this.bError = false;
		this.matColor = "primary";
		this.caption = this.idleCaption;
		this.button._elementRef.nativeElement.setAttribute("aria-label", this.caption);
		this.bDisabled = false;
	}
}